import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notificationController } from 'infrastructure/antd/controllers/notification-controller';
import { useTranslation } from 'react-i18next';
import dataService from 'services/dataService';
import { apiUpdateTask } from 'services/dataService/resources/oneplatform/api';

import { getTasksByPatientQueryKey } from './use-get-tasks-by-patient';

import type { ITaskCard, IUpdateTaskPayload, TaskApiError } from '../types';

export const useUpdateTask = (patientGuid: string) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: async ({
      taskGuid,
      payload,
    }: {
      taskGuid: string;
      payload: IUpdateTaskPayload;
    }) =>
      dataService.patchOnly<{
        task: ITaskCard;
      }>(apiUpdateTask(taskGuid), payload),
    onSuccess: () => {
      notificationController.success({
        message: t('tasksDrawer.editSuccess'),
      });
      queryClient.invalidateQueries(getTasksByPatientQueryKey(patientGuid));
    },
    onError: (error: unknown) => {
      const status = (error as TaskApiError)?.status;
      if (status === 409) {
        queryClient.invalidateQueries(getTasksByPatientQueryKey(patientGuid));
      }
      notificationController.error({
        message: t('tasksDrawer.editError'),
      });
    },
  });
};
